import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogAppBar from "@/shared/ui/SogAppBar.vue";
import SogAppBarSpacer from "@/shared/ui/SogAppBarSpacer.vue";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import router from "@/app/routes";
import apiAuth from "@/shared/services/apiAuth";
import {computed} from "vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonType} from "@/shared/ui/types/SogButtonType";
import SogMenu from "@/shared/ui/SogMenu.vue";
import {reactive, watch} from "vue";
import {mdiAccount} from "@mdi/js";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'AppBarComponent',
  emits: ['menuClick'],
  setup(__props, { emit: __emit }) {


const _emits = __emit;
const _accountStore = useAccountStore();
const {actionPerson} = storeToRefs(_accountStore)
const {authenticated} = storeToRefs(_accountStore)
const {installation} = storeToRefs(_accountStore)
const _accountItems: SogDropDownButtonItem[] = [{text: "Abmelden", id: "logout"}]
const _themeStore = useAccountStore()
const _accountMenuItems: SogDropDownButtonItem[] = reactive([{
  text: "", id: "1",
  svgIcon: mdiAccount,
  items: [{text: "Abmelden", id: "logout", svgIcon: mdiAccount}]
}])

const _personName = computed(() => {
  return actionPerson.value?.personName
})

const _shopName = computed(() => {
  return installation.value?.shortName
})

watch(actionPerson, (value) => {
  _accountMenuItems[0].text = actionPerson.value?.personName
}, {immediate: true})

const companyMenuItems = [
  {
    text: 'Company',
    items: [
      {text: 'About Us'},
      {text: 'Customers'},
      {text: 'Blog'},
      {text: 'Careers'}
    ]
  }
]


function onRootClick() {
  router.push("/");
  /*
    if (installation.value.shopId === "eVB_Aktivierung") {
      router.push("/");
    } else {
      window.open("https://www.agent22.eu", "_blank");
    }
  */
}

async function onLoginClick() {
  await apiAuth.login(undefined);
}

async function onAccountSelect(item: SogDropDownButtonItem) {
  if (item.id === "logout") {
    await apiAuth.logout();
    return
  }
}


function onMenuClick() {
  _emits("menuClick")
}

function onThemeClick() {
  _themeStore.dark = !_themeStore.dark;
}

async function p_onPurchase() {
  await router.push("/shoppingcartsingleproduct/purchase/producttype");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogAppBar, null, {
    default: _withCtx(() => [
      _createVNode(SogButton, {
        "mdi-icon": "mdi-menu",
        type: _unref(SogButtonType).Appbar,
        onClick: onMenuClick
      }, null, 8, ["type"]),
      _createVNode(SogButton, {
        type: _unref(SogButtonType).Appbar,
        onClick: onRootClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_shopName.value), 1)
        ]),
        _: 1
      }, 8, ["type"]),
      _withDirectives(_createVNode(SogButton, {
        type: _unref(SogButtonType).Appbar,
        "mdi-icon": "mdi-cart-plus",
        tooltip: "Einzeleinkauf",
        onClick: p_onPurchase
      }, null, 8, ["type"]), [
        [_vShow, _unref(_accountStore).isBranch]
      ]),
      _createVNode(SogAppBarSpacer),
      _withDirectives(_createVNode(SogButton, {
        "mdi-icon": "mdi-login",
        type: _unref(SogButtonType).Appbar,
        onClick: onLoginClick
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Anmelden ", -1)
        ]))]),
        _: 1
      }, 8, ["type"]), [
        [_vShow, _unref(authenticated)!==true]
      ]),
      _withDirectives(_createVNode(SogMenu, {
        items: _accountMenuItems,
        onSelect: onAccountSelect
      }, null, 8, ["items"]), [
        [_vShow, _unref(authenticated)]
      ])
    ]),
    _: 1
  }))
}
}

})